import Rollbar from 'rollbar'
import { getAppEnvironment } from 'src/utils/environment'

const environment = getAppEnvironment()
const baseConfig = {
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: environment,
}

export const clientConfig = {
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
  ...baseConfig,
}

export const serverInstance = new Rollbar({
  accessToken: process.env.ROLLBAR_SERVER_TOKEN,
  ...baseConfig,
})
